export const FETCH_PRODUCT = 'FETCH_PRODUCT'
export const AUTH_USER = 'AUTH_USER'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js